import { useContext } from 'react'

import { Modal } from '../ui_new'
import { useSignaturesActions } from '../../hooks'
import { LoaderContext } from '../../context'

const SignatureButtonsModal = ({ onClose, signature, onPreview }) => {
  const { setShowGlobalResponseLoader, setGlobalResponseLoaderText } = useContext(LoaderContext)
  const { uploadToCloud } = useSignaturesActions()

  // On preview
  const handlePreview = () => {
    onPreview(signature)
  }

  // On upload
  const handleCloudUpload = async () => {
    setShowGlobalResponseLoader(true)
    setGlobalResponseLoaderText('Téléchargement vers le cloud')
    try {
      await uploadToCloud({ signature })
      onClose()
    } catch (err) {
      // console.log(err)
    } finally {
      setShowGlobalResponseLoader(false)
      setGlobalResponseLoaderText('')
    }
  }

  return (
    <Modal onClose={onClose} className="modal-v2--medium">
      <div className="signature-buttons">
        <button className="btn" onClick={handlePreview}>Aperçu</button>
        <button className="btn" onClick={handleCloudUpload}>Envoyer vers l'Immocloud</button>
      </div>
    </Modal>
  )
}

export default SignatureButtonsModal